<template>
    <div class="box-checkbox">
        <div class="d-flex">
            <div
                id="modalpdpa-acceptpdpa-checkbox"
                class="icon-check"
                :class="{ error: !isFirstSave && error }"
                @click="clickImage()"
            >
                <img v-if="isActive" src="@/assets/icon/checkbox_active.svg" />
                <img v-else src="@/assets/icon/checkbox_inactive.svg" />
            </div>
            <span class="text-term">
                โดยการดำเนินการสมัครสมาชิก ข้าพเจ้ายอมรับ
                <u class="text-term-active" @click="clickTextTerm()"
                    >ข้อกำหนดและเงื่อนไข</u
                >
                และรับทราบ
                <u class="text-term-active" @click="clickTextPolicy()"
                    >ประกาศความเป็นส่วนตัว</u
                >
            </span>
        </div>
        <div class="d-flex mt-3">
            <div
                id="modalpdpa-acceptdata-checkbox"
                class="icon-check"
                @click="clickImage2()"
            >
                <img v-if="isActive2" src="@/assets/icon/checkbox_active.svg" />
                <img v-else src="@/assets/icon/checkbox_inactive.svg" />
            </div>
            <span class="text-term">
                ข้าพเจ้าต้องการรับข้อเสนอ ข่าวสาร การประกวดรางวัล และข้อมูล
                เกี่ยวกับ เนสท์เล่โพรเฟชชันนัล และ ผลิตภัณฑ์ของ
                เนสท์เล่โพรเฟชชันนัล
                ข้าพเจ้าเข้าใจว่าจะมีการประมวลข้อมูลส่วนบุคคลของข้าพเจ้า ตาม
                <u class="text-term-active" @click="clickTextPolicy()"
                    >ประกาศความเป็นส่วนตัวของเนสท์เล่</u
                >
                ข้าพเจ้ามีอายุไม่ต่ำกว่า 20 ปี
                และข้าพเจ้าเข้าใจว่าข้าพเจ้าสามารถถอนความยินยอมของข้าพเจ้าได้ทุกเมื่อ
            </span>
        </div>

        <b-modal
            id="modalPDPA"
            modal-class="modal-pdpa"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div class="header-container">
                    <div class="header-inner">
                        <div class="header-wrapper">
                            <img
                                src="@/assets/icon/nestle-header@3x.png"
                                alt="img-head"
                            />
                        </div>
                    </div>
                </div>
                <div class="modal-base-body">
                    <h2>นโยบายความเป็นส่วนตัว</h2>
                    <Privacy />
                </div>
            </div>
            <div class="btn-submit-wrapper">
                <div>
                    <button
                        id="modalpdpa-modalpdpa-confirmpdpa-btn"
                        class="btn-submit"
                        @click="clickConfirmPolicy()"
                    >
                        ตกลง
                    </button>
                </div>
            </div>
        </b-modal>
        <b-modal
            id="modalTerm"
            modal-class="modal-pdpa"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div class="header-container">
                    <div class="header-inner">
                        <div class="header-wrapper">
                            <img
                                src="@/assets/icon/nestle-header@3x.png"
                                alt="img-head"
                            />
                        </div>
                    </div>
                </div>
                <div class="modal-base-body">
                    <h2>ข้อตกลงและเงื่อนไขในการใช้งาน</h2>
                    <Term></Term>
                </div>
            </div>
            <div class="btn-submit-wrapper">
                <div>
                    <button
                        id="modalpdpa-modalpdpa-confirmterm-btn"
                        class="btn-submit"
                        @click="clickConfirmTerm()"
                    >
                        ตกลง
                    </button>
                </div>
            </div>
        </b-modal>
        <LoadingSSO :isShow="loading" />
    </div>
</template>
<script>
import Privacy from "@/module/Pdpapage/component/PrivacyDetail.vue";
import Term from "@/module/Pdpapage/component/TermDetail.vue";
import LoadingSSO from "@/components/LoadingSSO/Loading.vue";

export default {
    name: "ItemImageText",
    components: {
        Privacy,
        Term,
        LoadingSSO
    },
    props: {
        text: String,
        isFirstSave: Boolean,
        check: Boolean,
        check2: Boolean
    },
    data: function() {
        return {
            isActive: this.check,
            isActive2: this.check2,
            error: null,
            loading: false
        };
    },
    methods: {
        clickImage: function() {
            this.isActive = !this.isActive;
            if (this.isActive && this.error) {
                this.error = false;
            }
            this.$emit("input", this.isActive);
        },
        clickImage2: function() {
            this.isActive2 = !this.isActive2;
            this.$emit("inputPromo", this.isActive2);
            console.log(1111);
        },
        clickConfirmPolicy: function() {
            this.isActive = true;
            this.$bvModal.hide("modalPDPA");
        },
        clickConfirmTerm: function() {
            this.isActive = true;
            this.$bvModal.hide("modalTerm");
        },
        clickTextPolicy: function() {
            this.loading = true;
            setTimeout(() => {
                this.$bvModal.show("modalPDPA");
                this.$emit("clickText", this.isActive);
                this.loading = false;
            }, 500);
        },
        clickTextTerm: function() {
            this.loading = true;
            setTimeout(() => {
                this.$bvModal.show("modalTerm");
                this.$emit("clickText", this.isActive);
                this.loading = false;
            }, 500);
        },
        checkData() {
            this.error = true;
        }
    }
};
</script>

<style lang="scss" scoped>
$primary-color: #65513e;
$secondary-color: #f9613e;
$bg-color: #f4f4f4;
@import "@/style/base/baseUtility.scss";
.box-checkbox {
    @extend %unselectable;
    cursor: pointer;
    padding: 10px 0px;

    .icon-check {
        width: 20px;

        img {
            width: 20px;
            height: 20px;
            display: block;
            margin-top: 6px;
        }
        &.error {
            &::before {
                content: "";
                width: 20px;
                height: 20px;
                border: 1px solid red;
                border-radius: 3px;
                display: block;
                margin-top: 6px;
            }
            img {
                display: none;
            }
        }
    }
    .text-label-check {
        font-size: 1rem;
        font-weight: bold;
        margin: {
            top: 2px;
            left: 10px;
        }
    }
}

.text-term {
    font-family: "DBHeaventRegular";
    font-size: 1.5rem;
    margin-left: 12px;
    color: #707070;
}
.text-term-active {
    color: #007cba;
    font-size: 1.5rem;
}
::v-deep .modal {
    background: white;
    .modal-content {
        box-shadow: none;
    }
}
::v-deep .modal-backdrop {
    background-color: #fff;
    opacity: 1;
}
::v-deep .modal-body {
    .example::-webkit-scrollbar {
        display: none;
    }
    .modal-base {
        background-color: #fff;
        padding: 10px;
        border-radius: 15px;
        margin-bottom: 1rem;
        .header-container {
            background-color: $bg-color;
            margin: -11px;
            margin-bottom: 1.25rem;
            .header-inner {
                background-color: #fff;
                border-bottom-left-radius: 40px;
                margin-left: -0.5rem;
                .header-wrapper {
                    padding: 1.25rem;
                    img {
                        margin-right: 8px;
                        height: 3.125rem;
                    }
                }
            }
        }

        .modal-base-body {
            background-color: $bg-color;
            border-top-right-radius: 25px;
            border-bottom-right-radius: 25px;
            border-bottom-left-radius: 25px;
            font-family: "DBHeaventRegular";
            margin: -1.25rem -0.7rem 0 -0.7rem;
            h2 {
                font-size: 1.75rem;
                font-family: "DBHeaventMedium";
                color: $primary-color;
                padding: 20px 16px 0;
                text-align: center;
            }
            p {
                margin: 0;
                padding: 10px;
            }
        }
    }
}
.btn-submit-wrapper {
    width: 100%;
    box-shadow: none;
    .btn-submit {
        font-family: "DBHeaventMedium";
        width: 100%;
        height: 45px;
        border-radius: 5px;
        background-color: #65513e;
        border-color: transparent;
        font-size: 22px;
        color: white;
        line-height: 45px;
        text-align: center;
        // &.disabled {
        //     // opacity: 0.3;
        //     background: #d8d8d8;
        //     pointer-events: none;
        // }
    }
}
button {
    width: 100%;
}
</style>
